<script>
import AppBanner from '@/components/shared/AppBanner';
import ProjectSingle from '../components/projects/ProjectSingle.vue';
import Lightbox from '../components/projects/Lightbox.vue';
import Button from '../components/reusable/Button.vue';
import ClientLogos from '../components/shared/ClientLogos.vue';
import ProcessVideo from '../components/shared/ProcessVideo.vue';
import projects from '../data/projects';

export default {
	name: 'Home',
	components: {
		AppBanner,
		ProjectSingle,
		Lightbox,
		Button,
		ClientLogos,
		ProcessVideo,
	},
	data: () => {
		return {
			featuredProjects: ['Racecar', 'Commercial', 'Flat']
				.map((category) => projects.find((p) => p.category === category))
				.filter(Boolean),
			lightboxIndex: null,
		};
	},
	methods: {
		openLightbox(index) {
			this.lightboxIndex = index;
		},
		closeLightbox() {
			this.lightboxIndex = null;
		},
		prevPhoto() {
			this.lightboxIndex =
				(this.lightboxIndex - 1 + this.featuredProjects.length) %
				this.featuredProjects.length;
		},
		nextPhoto() {
			this.lightboxIndex =
				(this.lightboxIndex + 1) % this.featuredProjects.length;
		},
	},
};
</script>

<template>
	<div>
		<div class="container mx-auto">
			<!-- Banner -->
			<AppBanner />

			<!-- Process video -->
			<ProcessVideo v-reveal />

			<!-- Featured work preview -->
			<section class="pt-10 sm:pt-20" v-reveal>
				<div class="text-center">
					<p
						class="font-display uppercase tracking-wide text-3xl sm:text-4xl font-bold mb-2 text-primary-light"
					>
						Featured Work
					</p>
					<p class="font-general-regular text-ternary-light">
						A few examples from the shop &mdash; see the full gallery below.
					</p>
				</div>

				<div class="grid grid-cols-1 md:grid-cols-3 mt-10 sm:gap-10">
					<ProjectSingle
						v-for="(project, index) in featuredProjects"
						:key="project.id"
						:project="project"
						@open="openLightbox(index)"
					/>
				</div>

				<Lightbox
					:projects="featuredProjects"
					:index="lightboxIndex"
					@close="closeLightbox"
					@prev="prevPhoto"
					@next="nextPhoto"
				/>
			</section>

			<!-- Load more projects button -->
			<div class="mt-10 sm:mt-20 flex justify-center">
				<router-link
					to="/projects"
					class="font-display uppercase tracking-wider font-semibold flex items-center clip-corner px-6 py-3 shadow-glow hover:shadow-glow-lg bg-brand-600 hover:bg-brand-700 text-white text-lg sm:text-xl duration-300"
					aria-label="View Full Portfolio"
				>
					<Button title="View Full Portfolio" />
				</router-link>
			</div>

			<!-- Client logos -->
			<ClientLogos v-reveal />
		</div>
	</div>
</template>

<style scoped></style>
